import React from 'react';
import Consumables from './Consumables';

/** Inventory → Raw materials (sheet metal, plate, etc.). Not a BOM. */
const RawMaterials = () => <Consumables catalogType="raw_material" />;

export default RawMaterials;
